<template>
  <div class="login d-flex align-items-center justify-content-center bg-auth border-primary container">
		<div class="login__inner modal-container col-12 col-md-8 col-xl-6 my-5">
			<div class="login__wrap login__wrap--top modal-subcontainer modal-top" >
				<img class="login__logo" src="../assets/img/logo.png" />
				<p class="login__text mt-4">{{ subheadingText }}</p>
			</div>
			<div class="login__wrap login__wrap--bottom modal-subcontainer modal-bottom">
				<b-form @submit="onSubmit" class="form login__form" :class="{ 'is-sending': isSending }">
					<div class="form__input-wrap">
						<b-form-group label="Username" label-for="username">
							<b-form-input ref="username" id="username" type="text" v-model="form.username" :state="usernameStatus" required />
							<b-form-invalid-feedback v-if="usernameError" :force-show="true" orceid="usernameFeedback">{{ errorRequiredUsername }}</b-form-invalid-feedback>
						</b-form-group>
						<b-form-group label="Password" label-for="password">
							<b-form-input id="password" type="password" v-model="form.password" :state="passwordStatus" required autocomplete="off"/>
							<b-form-invalid-feedback v-if="passwordError" :force-show="true" id="passwordFeedback">{{ errorRequiredPassword }}</b-form-invalid-feedback>
						</b-form-group>
					</div>
					<b-form-invalid-feedback :force-show="loginError" class="form__error">{{ errorInvalid }}</b-form-invalid-feedback>
					<b-button type="submit"  size="lg" block class="form__submit btn-white mb-3">
						<span v-if="!isSending" >Enter</span>
						<b-spinner v-if="isSending" small label="Signing-in..." />
					</b-button>
				</b-form>
			</div>
		</div>
  </div>
</template>

<script>
import { isNil } from 'lodash'
import { mapActions } from 'vuex'

export default {
	name: 'login',
	props: {
		subheadingText: {
			type: String,
			default: "Welcome to your one-stop location for the world's medical literature. We provide access to over 50 million articles from over 5000 medical journals"
		},
		errorRequiredUsername: {
			type: String,
			default: "The username is required"
		},
		errorRequiredPassword: {
			type: String,
			default: "The password is required"
		},
		errorInvalid: {
			type: String,
			default: "Invalid username and/or password"
		}
	},
	computed: {
		loginError () {
			return ( isNil(this.errors.login) ? false : true )
		},
		usernameStatus () {
			return ( (this.usernameError || this.loginError) ? false : null );
		},
		usernameError () {
			return ( isNil(this.errors.username) ? false : true )
		},
		passwordStatus () {
			return ( (this.passwordError || this.loginError) ? false : null );
		},
		passwordError () {
			return ( isNil(this.errors.password) ? false : true )
		},
	},
	data () {
		return {
      form: {
        username: "",
        password: ""
			},
			isSending: false,
			errors: {}
		}
	},
	mounted () {
		this.$refs.username.focus()
	},
	methods: {
		...mapActions([ 'login' ]),
    onSubmit (event) {
      this.isSending = true;

			event.preventDefault();
			this.login( this.form )
				.then( () => this.$router.push( (isNil(this.$route.query.redirect) ? 'search-results' : this.$route.query.redirect) ) )
				.catch( err => this.errors = err )
				.finally( () => this.isSending = false )
    }
	}
}
</script>

<style lang="scss" scoped>
$color: black;
$color-invalid: #c33a40;
$color-invalid-bg: #fbecec;
$color-bg-alt: #f8f8f8;

.login {
	min-height: 100vh;

	&::after {
		content: '';
		position: absolute;
		top: 52%;
		display: block;
		height: 48%;
		width: 100%;
		background-color: $color-bg-alt;
	}

	&__inner {
		display: flex;
		flex-wrap: wrap;
		padding: 0;
		border: 1px solid lightgray;
		border-radius: 10px;
		z-index: 10;
		transform: translateY(-5vh);
	}

	&__wrap {
		padding: 25px;
		width: 100%;

		@media screen and (min-width: 1024px) {
			padding: 40px;
		}
		@media screen and (min-width: 1440px) {
			padding: 50px;
		}

		&--top {
			background-color: #FFF;
			border-top-right-radius: 10px;
			border-top-left-radius: 10px;
		}

		&--bottom {
			background-color: $color-bg-alt;
			border-bottom-left-radius: 10px;
			border-bottom-right-radius: 10px;
			padding: 20px;

			@media (min-width: 1024px) {
				padding: 30px;
			}
			@media (min-width: 1440px) {
				padding: 40px;
			}
		}
	}

	&__logo {
		width: 80%;
  	max-width: 350px;
	}
}

.form {

	&__input-wrap {
		display: flex;
		flex-wrap: wrap;
		border-width: 2px;
		opacity: 1;
		transition: opacity .3s ease-out;

		@media (min-width: 576px) {
			flex-wrap: nowrap
		}
	}

	&-group {
		width: 100%;

		@media screen and (min-width: 576px) {
			margin-left: 10px;
			margin-right: 10px;
		}


		label {
			font-weight: bold;
		}

		.invalid-feedback {
			color: $color-invalid;
		}
	}

	&-control {
		border-width: 2px;
		width: 100%;

		&.is-invalid {
			color: $color-invalid;
			border-color: currentColor;
			background-color: $color-invalid-bg;
		}
	}

	&__error {
		color: $color-invalid;
		text-align: center;
		font-size: inherit;
		margin-bottom: 1rem;
	}

	&__submit {
		margin: 0 auto;
		border-color: #D2DDEC;
		font-weight: bold;
		color: $color;
		width: 50%;
		max-width: 225px;
	}

	/**
	 * State
	 */
	&.is-sending {
		position: relative;

		.form__input-wrap {
			opacity: .5;

			&::after {
				content: '';
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				display: block;
				width: 100%;
				height: 100%;
				z-index: 10;
			}
		}
	}
}
</style>

